import moment from 'moment';

export function dateNumberToMoment(date) {
  if (typeof date === 'number') {
    switch (date.toString().length) {
      case 8:
        return moment(date, 'YYYYMMDD');
      case 14:
        return moment(date, 'YYYYMMDDHHmmss');
      case 12:
        return moment(date, 'YYYYMMDDHHmm');
      default:
        return moment(date);
    }
  } else {
    return moment(date);
  }
}

export function dateNumberToMomentUtc(date) {
  if (typeof date === 'number') {
    switch (date.toString().length) {
      case 8:
        return moment.utc(date, 'YYYYMMDD');
      case 14:
        return moment.utc(date, 'YYYYMMDDHHmmss');
      case 12:
        return moment.utc(date, 'YYYYMMDDHHmm');
      default:
        return moment.utc(date);
    }
  } else {
    return moment.utc(date);
  }
}

// Report dates arrive in two flavors that must not be treated alike.
//
// An *instant* is a real moment in time (client.created_dt, client_history.created_date).
// It is stored in UTC, so convert it into the viewer's timezone before reading a calendar
// day off it.
//
// A *calendar date* names a day and nothing else (action.due_date, sales_opp.close_date).
// It never had a timezone, so the UTC midnight a parser anchors it to is arbitrary —
// converting that anchor can only ever shift the value a day earlier, never correct it.
// Parse it as local midnight instead so it lines up with local date-range boundaries.
//
// One caveat: ai_activity.created_date and ai_activity_result.completion_date look like
// calendar dates but are really instants with the time truncated away, so the day they
// carry is the UTC one. They are read as calendar dates here because that is right for
// most of the day and wrong only for evening activity that rolls into the next UTC date —
// the reverse of treating them as instants, which is wrong for most of it. Reading
// ai_activity_result.last_modified_ts instead would make them correct outright.
export function reportInstant(date) {
  if (date === null || date === undefined) return moment.invalid();
  return dateNumberToMomentUtc(date).local();
}

export function reportCalendarDay(date) {
  if (date === null || date === undefined) return moment.invalid();
  const digits = String(date).replace(/\D/g, '');
  if (digits.length < 8) return moment.invalid();
  // Ignore any time component: a reminder is due on its day whatever hour got stored.
  return moment(digits.slice(0, 8), 'YYYYMMDD');
}

// True when `value` falls inside [startDate, endDate] compared at day granularity.
// Both bounds are browser-local, matching the rest of the reports.
export function isWithinReportRange(value, startDate, endDate) {
  return (
    value.isValid() && value.isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day'), 'day', '[]')
  );
}
